import { useEffect, useMemo, useState } from "react";
import { processDescriptionImages } from "utils/taskUtils";

const stringifyTextFiles = (files = []) => {
  if (!Array.isArray(files) || files.length === 0) return "";
  return files
    .map((tf) => `${tf.fileId || ""}:${tf.width || 0}:${tf.height || 0}`)
    .join("|");
};

const useProcessedDescription = (description = "", textFiles = []) => {
  const normalizedTextFiles = useMemo(
    () => (Array.isArray(textFiles) ? textFiles : []),
    [textFiles],
  );
  const textFilesSignature = useMemo(() => stringifyTextFiles(normalizedTextFiles), [normalizedTextFiles]);
  const [processedDescription, setProcessedDescription] = useState(description || "");

  useEffect(() => {
    let active = true;
    const rawDescription = description || "";

    if (!rawDescription) {
      if (active) setProcessedDescription("");
      return () => {
        active = false;
      };
    }

    const hasArrayPattern = /\[[0-9a-fA-F-]{36}\s*,\s*\d+\s*,\s*\d+\]/.test(rawDescription);
    console.info("[useProcessedDescription] description snapshot", {
      length: rawDescription.length,
      hasArrayPattern,
      textFiles: normalizedTextFiles,
    });

    const processDescription = async () => {
      try {
        const processed = await processDescriptionImages(rawDescription, normalizedTextFiles);
        if (active) {
          setProcessedDescription(processed || rawDescription);
        }
      } catch (err) {
        console.error("[useProcessedDescription] failed to process description images", err);
        if (active) {
          setProcessedDescription(rawDescription);
        }
      }
    };

    processDescription();

    return () => {
      active = false;
    };
  }, [description, textFilesSignature, normalizedTextFiles]);

  return processedDescription;
};

export default useProcessedDescription;
